// extracted by mini-css-extract-plugin
export default {"textInputWrapper":"styles_textInputWrapper__TnTAv","inputBox":"styles_inputBox__96BIC"};